import React, { MouseEvent } from 'react';
import { Box } from 'grommet';
import {
    OutsideBoxDisclaimer,
    DisclaimerQuestionText,
    DisclaimerInsideText,
    CancelButton,
    OkButton
} from '../makePaymentOptions/paymentOptionsStyles/makePaymentOptionsStyles';
import Modal from '../modal/Modal';
import { ButtonWrapper, LeftLaterWrapper, LeftWrapper, MessageTextBox, OuterLaterWrapper, OuterLeftWrapper, StyledPrimaryButton, StyledPrimaryButtonWithdraw, StyledPrimarySummaryButton, StyledReturnButton, WarningIconSizing, WrapperOne } from './gpaCancelPolicyStyles';
import { Info, Warning } from '../../icons';


interface LaterModalProps {
    showModal: boolean;
    closeModal: Function;
    clearForm: Function;
}

export default ({ showModal, closeModal, clearForm }: LaterModalProps) => {
    const clickHandlerYes = () => {
        closeModal();
    };

    const clickHandler = () => {
        closeModal();
        clearForm();
    };

    return (
        <Box>
            <Modal
                showModal={showModal}
                onEsc={() => { }}
                onClickOutside={() => { }}
            >
                <OutsideBoxDisclaimer>
                    <Box>
                        <MessageTextBox>
                            <WarningIconSizing>
                                <Warning />
                            </WarningIconSizing>
                            <div>
                                Please submit the cancellation request at later date once the signed LPR is obtained and available for the upload.
                            </div>
                        </MessageTextBox>

                        <OuterLaterWrapper>
                            <LeftLaterWrapper>
                                <WrapperOne>
                                    <ButtonWrapper>
                                        <StyledPrimarySummaryButton
                                            onClick={() => {
                                                clickHandler();
                                            }}
                                        >
                                            Back to Account Summary
                                        </StyledPrimarySummaryButton>
                                    </ButtonWrapper>
                                </WrapperOne>
                            </LeftLaterWrapper>
                            <LeftLaterWrapper>
                                <WrapperOne>
                                    <ButtonWrapper>
                                        <StyledReturnButton
                                            onClick={() => {
                                                clickHandlerYes();
                                            }}
                                        >
                                            Return to page to edit
                                        </StyledReturnButton>
                                    </ButtonWrapper>
                                </WrapperOne>
                            </LeftLaterWrapper>
                        </OuterLaterWrapper>
                    </Box>
                </OutsideBoxDisclaimer>
            </Modal>
        </Box>
    );
};
